<template>
  <div v-if="validLabels.length > 0" class="label-chips">
    <span
      v-for="label in validLabels"
      :key="label"
      class="label-chip"
      :class="`label-chip--${label}`"
    >
      {{ labelText(label) }}
    </span>
  </div>
</template>

<script>
const LABEL_VALUES = {
  CAMPAIGN: 'campaign',
  LIMITED_TIME: 'limited_time',
  MAIL_SLOT: 'mail_slot'
}

const LABEL_TEXTS = {
  [LABEL_VALUES.CAMPAIGN]: 'キャンペーン対象',
  [LABEL_VALUES.LIMITED_TIME]: '期間限定',
  [LABEL_VALUES.MAIL_SLOT]: 'ポスト投函'
}

const LABEL_ORDER = [
  LABEL_VALUES.CAMPAIGN,
  LABEL_VALUES.LIMITED_TIME,
  LABEL_VALUES.MAIL_SLOT
]

export default {
  props: {
    labels: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    validLabels() {
      const set = new Set(this.labels || [])
      // Enforce required display order and filter unknowns
      return LABEL_ORDER.filter(l => set.has(l))
    }
  },
  methods: {
    labelText(label) {
      return LABEL_TEXTS[label]
    }
  }
}
</script>

<style lang="scss" scoped>
.label-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.label-chip {
  font-size: 1rem;
  font-weight: bold;
  padding: 4px;
  border-radius: 4px;
  line-height: 1;
  white-space: nowrap;

  &--campaign {
    background-color: $brown-1;
    color: $primary-lighten;
  }

  &--limited_time {
    background-color: $brown-1;
    color: $primary-lighten;
  }

  &--mail_slot {
    background-color: $primary-lighten;
    color: $brown-1;
  }
}
</style>
